import React, { useState } from "react";
import { Home, Info, MapPin, Phone, ShoppingBag } from "lucide-react";
import { motion } from "framer-motion";

export default function RightRail() {
  const [open, setOpen] = useState(null); // 'home'|'about'|'products'|'locations'|'contact'

  const items = [
    { id: "home", icon: <Home />, label: "Home" },
    { id: "about", icon: <Info />, label: "About" },
    { id: "products", icon: <ShoppingBag />, label: "Products" },
    { id: "locations", icon: <MapPin />, label: "Locations" },
    { id: "contact", icon: <Phone />, label: "Contact" },
  ];

  return (
    <>
      <div className="fixed right-6 top-1/3 z-40 flex flex-col items-center gap-3">
        {items.map((it) => (
          <div key={it.id} className="relative">
            <button
              onMouseEnter={() => setOpen(it.id)}
              onMouseLeave={() => setOpen(null)}
              onClick={() => setOpen(open === it.id ? null : it.id)}
              className="w-12 h-12 flex items-center justify-center rounded-xl right-rail text-gray-200 hover:scale-105 transition neon-glow"
              title={it.label}
            >
              {it.icon}
            </button>

            {/* tooltip */}
            <div className={`absolute right-14 top-1/2 -translate-y-1/2 text-sm px-3 py-1 rounded-md ${open === it.id ? "block" : "hidden"} bg-black/70 border border-white/5`}>
              {it.label}
            </div>
          </div>
        ))}
      </div>

      {/* info panels */}
      <AnimatePanel open={open} onClose={() => setOpen(null)} />
    </>
  );
}

function AnimatePanel({ open, onClose }) {
  const content = {
    home: { title: "Welcome", body: "Jump to the best picks and neon deals." },
    about: { title: "About ShopAt1Stop", body: "We curate premium smoke accessories for enthusiasts." },
    products: { title: "Products", body: "Explore grinders, glassware, trays, and vapes." },
    locations: { title: "Locations", body: "Visit our stores at your nearest city!" },
    contact: { title: "Contact Us", body: "Call: +91 99999 99999 — Email: hello@shopat1stop.com" },
  };

  if (!open) return null;

  return (
    <motion.div
      initial={{ opacity: 0, x: 50 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: 50 }}
      className="fixed right-28 top-1/3 z-40 w-96 p-6 rounded-2xl text-gray-200 bg-gradient-to-b from-black/70 to-black/50 border border-white/5 shadow-2xl"
    >
      <div className="flex justify-between items-start">
        <div>
          <h4 className="text-lg font-bold neon-text">{content[open].title}</h4>
          <p className="text-sm text-gray-300 mt-2">{content[open].body}</p>
        </div>
        <button onClick={onClose} className="text-gray-400 hover:text-white">✕</button>
      </div>
    </motion.div>
  );
}
